function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import OrganizationAdmin, { ActiveOrganizationMemberships, InvitationOrganizationMemberships, PendingOrganizationMemberships, WaitForOrganizationApprovalStatement } from 'modules/OrganizationAdmin';
import * as shapes from '../../shapes';
var _React_PureComponent;
class Admin extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        if (!this.isActiveAdmin) {
            return;
        }
        this.props.onFetchOrganizationMemberships();
    }
    componentWillUnmount() {
        if (!this.isActiveAdmin) {
            return;
        }
        this.props.onClearOrganization();
    }
    get isActiveAdmin() {
        return this.props.organizationMembership.isAdmin && this.props.organizationMembership.status === 'Active';
    }
    render() {
        if (!this.isActiveAdmin) {
            return null;
        }
        if (this.props.organizationMembership.organization.status === 'Pending') {
            return /*#__PURE__*/ _jsx(WaitForOrganizationApprovalStatement, {
                adminOrganizationMembership: this.props.organizationMembership
            });
        }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(PendingOrganizationMemberships, {
                    adminOrganizationMembership: this.props.organizationMembership
                }),
                /*#__PURE__*/ _jsx(InvitationOrganizationMemberships, {
                    adminOrganizationMembership: this.props.organizationMembership
                }),
                /*#__PURE__*/ _jsx(ActiveOrganizationMemberships, {
                    adminOrganizationMembership: this.props.organizationMembership
                })
            ]
        });
    }
}
_define_property(Admin, "propTypes", {
    // Explicit props
    organizationMembership: shapes.organizationMembership.isRequired,
    // Implicit actions
    onClearOrganization: PropTypes.func,
    onFetchOrganizationMemberships: PropTypes.func
});
const mapDispatchToProps = (dispatch, props)=>{
    const { organization } = props.organizationMembership;
    return {
        onClearOrganization: ()=>dispatch(OrganizationAdmin.actions.clearOrganization()),
        onFetchOrganizationMemberships: ()=>dispatch(OrganizationAdmin.actions.fetchOrganizationMemberships(organization))
    };
};
const ConnectedAdmin = connect(null, mapDispatchToProps)(Admin);
export default ConnectedAdmin;
